import { ChevronDown } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ChevronDownIcon = createLucideIcon(ChevronDown);
